export default "__VITE_ASSET__7d8a18e4__"